import React from 'react';
import PropTypes from 'prop-types';

import StyledSelect from 'components/ui/StyledReactSelect';

import { packageBookingFares } from 'constants/fares';

const priority = {
  PUB: 1
};

const FareType = ({ fareTypeList, onSelect, value, isPackageBooking = false }) => {
  const fareTypes = isPackageBooking ? fareTypeList.filter((fare) => packageBookingFares.includes(fare.code)) : fareTypeList;
  const options = fareTypes
    .map(({ code: value = '', name: label = '' }) => ({
      value,
      label
    }))
    .sort((a, b) => {
      if (priority[a.value] && priority[b.value]) {
        return priority[b.value] - priority[a.value];
      } else if (priority[b.value] || priority[a.value]) {
        return priority[a.value] || priority[b.value];
      } else {
        return a.label.localeCompare(b.label);
      }
    });

  const handleChange = (newValue) => onSelect({ value: newValue.value, name: newValue.label });

  return (
    <StyledSelect
      id="fare-select"
      name="fare-select"
      className="react-select-container"
      classNamePrefix="react-select"
      width="200px"
      height="30px"
      mr="8px"
      options={options}
      value={options.find((o) => o.value === value)}
      onChange={handleChange}
    />
  );
};

FareType.propTypes = {
  fareTypeList: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  onSelect: PropTypes.func,
  value: PropTypes.string,
  isPackageBooking: PropTypes.bool
};

export default FareType;
